import {
  LOAD_API_INITIAL_DATA,
  LOAD_API_INITIAL_DATA_FAILED,
  LOAD_API_INITIAL_DATA_SUCCESS,
} from "../types"

const initialState = {
  airports: [],
  operationTypes: [],
  googleMapsKey: "",
  loading: false,
  error: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case LOAD_API_INITIAL_DATA:
      return {
        ...state,
        loading: true,
        error: false,
        airports: [],
        operationTypes: [],
        googleMapsKey: "",
      }
    case LOAD_API_INITIAL_DATA_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
        airports: [],
        operationTypes: [],
        googleMapsKey: "",
      }
    case LOAD_API_INITIAL_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        airports: action.payload.Airports,
        operationTypes: action.payload.OperationType,
        googleMapsKey: action.payload.GoogleMapsKey ?? "",
      }
    default:
      return state
  }
}
